import React from 'react';

import styled from 'styled-components';

const Container = styled.div`
  display: block;
  width: 90%;
  max-width: 920px;
  overflow: hidden;
  margin: 2.5rem auto;
  ${Styles.mobile`
    margin: 1.5rem auto;
  `}
`;
const Video = styled.video`
  width: 100%;
  display: block;
  border-radius: 4px;
`;

const VideoCaption = styled.figcaption`
  padding-top: 1rem;
  font-size: 0.875rem;
  & > a {
    color: ${Styles.color.primary};
    margin-right: 0.33rem;
  }
`;

export default class VideoWidget extends React.Component {
  render() {
    return (
      <>
        <Container>
          <Video video={this.props.video} controls>
            <source src={this.props?.video?.locale?.asset?.url} type="video/mp4" />
          </Video>
          <VideoCaption>
            <a href={this.props?.attributionLink}>Video Source</a>
            {this.props?.caption?.locale}
          </VideoCaption>
        </Container>
      </>
    );
  }
}
